define('views/modules/calendar/nutrition/food/list/base-food-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/modules/calendar/nutrition/nutrient/nutrient-component',
    // templates
    'text!templates/modules/calendar/nutrition/food/list/food-list-item.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VNutrientComponent,
    // templates
    TFoodItem
) {

    var VBaseFoodItem = Backbone.Epoxy.View.extend({
        template: TFoodItem,
        // touchstart - Mandatory for IPAD or click event isn't firing
        events: {
            'click .food-show-nutriment': 'onShowNutrient',
            'touchstart .food-show-nutriment': 'onShowNutrient',
        },
        regions: {
            favorite: '.favorite-icon',
            nutrient: '.nutrient-component'
        },

        constructor: function(opt) {
            var proto = VBaseFoodItem.prototype;
            this.options = opt || {};
            this.regions = _.extend({}, proto.regions, this.regions);
            this.events = _.extend({}, proto.events, this.events);
            this.className = 'food-list-item urowfix urow-relative ' + (this.className || '');

            this.view = {};

            VBaseFoodItem.__super__.constructor.apply(this, arguments);
        },

        render: function() {
            var html = Mustache.render(this.template, this.getData());
            this.$el.empty().append(html);
            this.generateZones();
            var nutrient = this.view.nutrient;
            if (nutrient) this.zone.$nutrient.html(nutrient.render().el);
            return this;
        },

        remove: function() {
            this.undelegateEvents();
            this.$el.fadeOut("fast", VBaseFoodItem.__super__.remove.bind(this));
        },

        setActive: function(value) {
            this.$el.toggleClass('active', value);
        },

        isActive: function() {
            return this.$el.hasClass('active');
        },

        isFavoriteFood: function() {
            return this.favorite;
        },

        getData: function() {
            var defaultServing = this.options.defaultServing,
                displayTitle = this.getServing().getDisplayTitle();

            return _.extend(this.model.toJSON(), {
                defaultServing: defaultServing ? displayTitle : false
            });
        },

        getServing: function() {
            return this.getFood().getDefaultServing();
        },

        getNutrients: function() {
            return this.getServing().getNutrients();
        },

        toggleNutrient: function(value) {
            var view = this.view,
                nutrient = view.nutrient,
                $elem = this.zone.$nutrient,
                food = this.getFood(),
                serving = this.getServing();

            if (!nutrient) {
                nutrient = view.nutrient = new VNutrientComponent();
                $elem.html(nutrient.render().el);
            }
            if (!serving) {
                food.fetch({
                    context: this,
                    success: function() {
                        this._toggleNutrient(value);
                    }
                });
            } else {
                this._toggleNutrient(value);
            }

        },

        _toggleNutrient: function(value) {
            var nutrient = this.view.nutrient,
                nutrientObj = this.getNutrients(),
                serving = this.getServing().get('qty') + ' x ' + this.getServing().get('name');
            nutrient.setNutrients(nutrientObj);
            nutrient.setServing(serving);
            nutrient.toggle(value);
        },

        onShowNutrient: function(e) {
            this.toggleNutrient();
        },

    });

    return VBaseFoodItem;

});

